import Vue from 'vue'
import Router from 'vue-router'
import routesMap from './routesMap'
import LayoutRoot from "@/views/layout/LayoutRoot.vue"

Vue.use(Router)
export default new Router({
  routes: [{
      path: '/',
      name: "LayoutRoot",
      component: LayoutRoot,
      // children: [{
      //   path: '/',
      //   component: () => {
      //     let accountInfo = sessionStorage.getItem("accountInfo");
      //     if (accountInfo) {
      //       if (JSON.parse(accountInfo).account_type == 3) {
      //         return import('@/views/super/index/SuperIndex.vue')
      //       } else if (JSON.parse(accountInfo).account_type == 2) {
      //         return import('@/views/merchant/index/CompanyIndex.vue')
      //       } else if (JSON.parse(accountInfo).account_type == 1) {
      //         return import('@/views/shop/index/ShopIndex.vue')
      //       }
      //     } else {
      //       return
      //     }
      //   },
      // }]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/Login.vue'),
    },
    {
      path: '/excel',
      name: 'Excel',
      component: () => import('@/views/excel/Excel.vue'),
    },
    {
      path: '/not_found_page',
      name: 'NotFoundPage',
      component: () => import('@/views/404/NotFoundPage.vue'),
    },
    {
      path: '/h5_face_collection',
      name: 'FaceCollection',
      component: () => import('@/views/H5/FaceCollection.vue'),
    },
    {
      path: "*",
      redirect: "/not_found_page"
    },
    ...routesMap.superRoutes,
    ...routesMap.superOtherRoutes,
    ...routesMap.merchantRoutes,
    ...routesMap.merchantOtherRoutes,
    ...routesMap.shopRoutes,
    ...routesMap.shopOtherRoutes
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js